import { FC } from "react";
import RichTextEditor from "../libraryItem/course/RichTextEditor";
import TiptapEditorContextProvider from "../libraryItem/course/contexts/TiptapEditorContext";
import { cn } from "@src/lib/utils/cn";
import { CSSProperties } from "react";
import { TextV4Variant, textV4Variants } from "@src/lib/ui/Text";

type Props = {
  text: string;
  isSelected: boolean;
  maxWidth?: number;
  styleOverrides?: CSSProperties;
  className?: string;
  variant?: TextV4Variant;
};

const RichTextPreview: FC<Props> = ({
  text,
  isSelected,
  styleOverrides,
  className,
  variant,
}) => {
  return (
    <TiptapEditorContextProvider>
      <RichTextEditor
        text={text}
        disabled={true}
        hasEditContentPermission={false}
        enableMentions
        disableTextVariants={!!variant}
        className={cn(
          "m-0 truncate text-text-primary",
          variant ? textV4Variants({ variant }) : "text-sm leading-5",
          isSelected && "text-gray-11",
          className,
        )}
        styles={styleOverrides}
      />
    </TiptapEditorContextProvider>
  );
};

export default RichTextPreview;
